import { append, remove, assocPath } from 'ramda';
import { find, propEq } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import * as actions from 'constants/actionTypes';

const showConfirmModal = (state) => notEmpty(state) &&
    !find(propEq('type', actions.OPEN_MODAL_CONFIRM), state);

export const modalsReducer = (state = [], action) => {
    switch(action.type) {
        case actions.OPEN_MODAL_WORKSHEET_UNSUPPORTED:
        case actions.OPEN_MODAL_WORKSHEET_SETTINGS:
        case actions.OPEN_MODAL_PROJECT_SETTINGS:
        case actions.OPEN_MODAL_PROJECT_MASS_SETTINGS:
        case actions.OPEN_MODAL_CANCEL_REQUEST:
        case actions.OPEN_MODAL_APPROVE_PERSON:
        case actions.OPEN_MODAL_REJECT_PERSON:
        case actions.OPEN_MODAL_APPROVE_PROJECT:
        case actions.OPEN_MODAL_REJECT_PROJECT:
        case actions.OPEN_MODAL_EVENT_CREATE:
        case actions.OPEN_MODAL_EVENT_SCRIPT:
        case actions.OPEN_MODAL_SOTRMEET_CREATE:
        case actions.OPEN_MODAL_TASK_CREATE:
        case actions.OPEN_MODAL_TASK_UPDATE:
        case actions.OPEN_MODAL_SOTRMEET_UPDATE:
        case actions.OPEN_MODAL_CREATE_APPLICATION:
        case actions.OPEN_MODAL_DOCUMENT_LINK:
        case actions.OPEN_MODAL_STATE_PERSON:
        case actions.OPEN_MODAL_WORKSHEET_MASS_SETTINGS:
        case actions.OPEN_MODAL_MASS_STAGE:
        case actions.OPEN_MODAL_EDUCATION_EVENT:
        case actions.OPEN_MODAL_AVATAR:
        case actions.OPEN_MODAL_APPLICATION_APPROVE:
        case actions.OPEN_MODAL_APPLICATION_CANCEL:
        case actions.OPEN_MODAL_ACTION_VACANCY:
        case actions.OPEN_MODAL_SCENARIO_TEST:
        case actions.OPEN_MODAL_SCENARIO:
        case actions.OPEN_MODAL_TRAINER_MARK:
        case actions.OPEN_MODAL_SCORM:
        case actions.OPEN_MODAL_SCENARIO_BOOK:
        case actions.OPEN_MODAL_METRO_REQUEST_ROUTE:
        case actions.OPEN_MODAL_METRO_REQUEST_POSITION:
        case actions.OPEN_MODAL_METRO_REQUEST_APPROVE:
        case actions.OPEN_MODAL_METRO_REQUEST_REJECT:
        case actions.OPEN_MODAL_METRO_REQUEST_CANCEL:
            return append({
                type: action.type,
                params: action.payload,
                visible: true
            }, state);
        case actions.LOCATION_CHANGE:
            return showConfirmModal(state) ? (
                append({ type: actions.OPEN_MODAL_CONFIRM, visible: true }, state)
            ) : state;
        case actions.CLOSE_MODAL:
            return assocPath([action.payload, 'close'], true, state);
        case actions.REMOVE_MODAL:
            return remove(action.payload, 1, state);
        case actions.HIDE_MODAL:
            return assocPath([action.payload, 'visible'], false, state);
        case actions.SHOW_MODAL:
            return assocPath([action.payload, 'visible'], true, state);
        case actions.CLOSE_ALL_MODALS:
            return [];
        case actions.LOGOUT:
            return [];
        default:
            return state;
    }
};
